import { $http } from "@/utils/http";
import {
    GET_MAIN_SLIDER_LOADING,
    SET_MAIN_SLIDER,
    SET_BANNER_LIST,
    SET_BANNER_LIST_LOADING,
    GET_CLIENTS_SLIDER_LOADING,
    SET_CLIENTS_SLIDER,
} from "../mutation-types";

import { GET_MAIN_SLIDER, GET_BANNER_LIST, GET_CLIENTS_SLIDER } from "../action-types";

const state = {
    mainSlider: null,
    mainSliderLoading: false,
    bannerList: null,
    bannerListLoading: false,
    clientsSlider: null,
    clientsSliderLoading: false,
    articlesList: null,
    articlesListLoading: false,
};

const getters = {
    mainSlider: state => state.mainSlider,
    mainSliderLoading: state => state.mainSliderLoading,
    bannerList: state => state.bannerList,
    bannerListLoading: state => state.bannerListLoading,
    clientsSlider: state => state.clientsSlider,
    clientsSliderLoading: state => state.clientsSliderLoading,
};

const actions = {
    [GET_MAIN_SLIDER]: async ({ commit }) => {
        commit(GET_MAIN_SLIDER_LOADING, true);
        try {
            const response = await $http.get(`v1/slider`);
            commit(SET_MAIN_SLIDER, response.data.data);
        } catch (e) {
            throw e;
        } finally {
            commit(GET_MAIN_SLIDER_LOADING, false);
        }
    },
    [GET_BANNER_LIST]: async ({ commit }) => {
        commit(SET_BANNER_LIST_LOADING, true);
        try {
            const response = await $http.get(`v1/images`);
            commit(SET_BANNER_LIST, response.data);
        } catch (e) {
            throw e;
        } finally {
            commit(SET_BANNER_LIST_LOADING, false);
        }
    },
    [GET_CLIENTS_SLIDER]: async ({ commit }) => {
        commit(GET_CLIENTS_SLIDER_LOADING, true);
        try {
            const response = await $http.get(`v1/clients`);
            commit(SET_CLIENTS_SLIDER, response.data.data);
        } catch (e) {
            throw e;
        } finally {
            commit(GET_CLIENTS_SLIDER_LOADING, false);
        }
    },
};

const mutations = {
    [GET_MAIN_SLIDER_LOADING](state, status) {
        state.mainSliderLoading = status;
    },
    [SET_MAIN_SLIDER](state, list) {
        state.mainSlider = list;
    },
    [SET_BANNER_LIST](state, list) {
        state.bannerList = list;
    },
    [SET_BANNER_LIST_LOADING](state, status) {
        state.bannerListLoading = status;
    },
    [GET_CLIENTS_SLIDER_LOADING](state, status) {
        state.clientsSliderLoading = status;
    },
    [SET_CLIENTS_SLIDER](state, list) {
        state.clientsSlider = list;
    },
};
export default {
    state,
    getters,
    actions,
    mutations,
};
